import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

const Privacy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pages/privacy`);
        if (!response.ok) throw new Error('Failed to fetch privacy policy');
        const data = await response.json();
        setContent(data.content);
      } catch (error) {
        console.error('Error fetching privacy policy:', error);
        setContent('Privacy Policy content is currently unavailable.');
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#22c55e]"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="glass-card p-8">
        <div className="prose prose-invert max-w-none">
          <ReactMarkdown
            components={{
              h1: ({node, children, ...props}) => children ? <h1 className="text-4xl font-bold mb-6" {...props}>{children}</h1> : null,
              h2: ({node, children, ...props}) => children ? <h2 className="text-3xl font-bold mb-4" {...props}>{children}</h2> : null,
              h3: ({node, children, ...props}) => children ? <h3 className="text-2xl font-bold mb-3" {...props}>{children}</h3> : null,
              p: ({node, children, ...props}) => <p className="mb-4" {...props}>{children}</p>,
              ul: ({node, children, ...props}) => <ul className="list-disc list-inside mb-4" {...props}>{children}</ul>,
              ol: ({node, children, ...props}) => <ol className="list-decimal list-inside mb-4" {...props}>{children}</ol>,
              li: ({node, children, ...props}) => <li className="mb-2" {...props}>{children}</li>,
              strong: ({node, children, ...props}) => <strong className="font-bold text-[#22c55e]" {...props}>{children}</strong>,
              em: ({node, children, ...props}) => <em className="italic text-gray-300" {...props}>{children}</em>,
              a: ({node, children, href, ...props}) => children ? (
                <a 
                  href={href}
                  className="text-[#22c55e] hover:text-[#15803d] underline" 
                  {...props}
                >
                  {children}
                </a>
              ) : null,
              blockquote: ({node, children, ...props}) => (
                <blockquote className="border-l-4 border-[#22c55e] pl-4 my-4 italic" {...props}>
                  {children}
                </blockquote>
              )
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 